"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useRequest_1 = require("./useRequest");
const react_native_uuid_1 = __importDefault(require("react-native-uuid"));
const system_1 = require("@rahtab/system");
function useFetchCallType(callType, { skip = false, onCompleted, url, ...options } = {}) {
    const dispatch = system_1.useSystemDispatch();
    const { setRequest, removeRequest } = system_1.networkLink;
    const request = useRequest_1.useRequest({ url });
    const [data, setData] = react_1.useState(undefined);
    const [traceId] = react_1.useState(react_native_uuid_1.default.v4().toString());
    const networkLinkRetry = system_1.useSystemSelector((state) => state.networkLink.retry);
    const networkLinkRequest = system_1.useSystemSelector((state) => {
        if (!state.networkLink.requests[traceId]) {
            return {
                traceId,
                loading: !skip,
                called: false,
                error: undefined,
            };
        }
        return state.networkLink.requests[traceId];
    });
    const loading = () => {
        dispatch(setRequest({
            ...networkLinkRequest,
            loading: true,
            error: undefined,
        }));
    };
    const done = (d) => {
        onCompleted?.(d);
        setData(d);
        dispatch(setRequest({
            ...networkLinkRequest,
            error: undefined,
            loading: false,
            called: true,
        }));
    };
    const failed = (code) => {
        dispatch(setRequest({
            ...networkLinkRequest,
            loading: false,
            called: true,
            error: {
                code,
                source: `CT: ${callType}`,
            },
        }));
    };
    const fetchMore = async (arg) => {
        const { params = options.params, data: d = options.data } = arg || {};
        try {
            const requestData = await request(callType, { ...options, params, data: d });
            done(requestData);
        }
        catch (e) {
            failed(e.code);
        }
    };
    const fetch = async (arg) => {
        loading();
        fetchMore(arg);
    };
    react_1.useEffect(() => {
        dispatch(setRequest(networkLinkRequest));
        return () => {
            dispatch(removeRequest({ traceId }));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react_1.useEffect(() => {
        if (networkLinkRequest.error && !networkLinkRequest.loading) {
            fetch();
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [networkLinkRetry]);
    react_1.useEffect(() => {
        if (!skip)
            fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.params, skip]);
    return [fetch, { ...networkLinkRequest, data, fetchMore }];
}
exports.default = useFetchCallType;
